import { useContext } from "react";

import { TrackingContext } from "./TrackingContext";

export function useTrackingAdapter() {
  const store = useContext(TrackingContext);

  return store.getState().trackingAdapter;
}
